import React, { Component } from "react";
import swal from "@sweetalert/with-react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { dynamicCurrencyFormator } from "../../../../utils/functions";
import { checkPermission, checkForTireView } from "../../../../Helper";
import AddDeal from "./components/addDeal";
import "./myReactSelect.css";
import { Button, Col, Form } from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "./formsTable.css";
import { Modal } from "react-bootstrap";
import "./baseForms.css";
import axios from "axios";
import { baseurl } from "../../../../baseurl";
import { GetIp } from "./../../../../views/Forms/ShortCutComponents/Get_ip";
import moment from "moment";
var thisContex;
var token = localStorage.getItem("token");
var username = localStorage.getItem("username");
function indexN(cell, row, enumObject, index) {
  return <div>{index + 1}</div>;
}
let companyId = localStorage.getItem("companyId");
class DealOverview extends Component {
  constructor(props) {
    super(props);

    this.toggleAddNew = this.toggleAddNew.bind(this);
    this.hsandleChange = this.handleChange.bind(this);
    this.handleChangeEdit = this.handleChangeEdit.bind(this);
    ////////////////////////
    this.addToggle = this.addToggle.bind(this);
    this.state = {
      showModalAddNew: false,
      data: [],
      govtDesc: "",
      govtDescE: "",
      id: "",
      permission: true,
      rolesPermission: false,
      itemAdd: "",
      showModalOpen: false,
      showItemForm: false,
      tableData: [],
      row_BranchId: "",
      isLoadedTableData: false,
      defaultSalesTaxOptions: [],
      defaultQuanShow: "0",
      defaultRateShow: "0",
      activity: props?.propData?.location?.rowData?.referencePk,
    };
    thisContex = this;
  }
  showUpdateModal = (cell, row) => {
    this.setState({
      showItemForm: !this.state.showItemForm,
      row_id: row.Id,
      updateCheck: 1,
    });
    this.updateModalToggle();
  };
  updateModalToggle = () => {
    this.setState({
      UpdateModal: !this.state.UpdateModal,
    });
  };
  itemLoad = () => {
    this.setState({
      row_id: "-1",
      showItemForm: !this.state.showItemForm,
    });
    this.getData();
  };
  getUserIp = async function () {
    let res = await GetIp();
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
  };
  setDelete = async (row) => {
    const deleteCheck = await this.asyncRollCheck(3);
    if (deleteCheck) {
      return;
    }
    const detIds = "(" + row.deal_prop_ids + ")";
    let rowId = row.id;
    let journalId = row.journal_id;
    let tempThis = this;
    console.log("row", row);
    let dealDate = row.deal_date
      ? moment(row.deal_date).format("YYYY-MM-DD")
      : null;
    let { userIp, userCountry } = await this.getUserIp();

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(
            `${baseurl}/RealEstate/DelDeal`,
            {
              id: rowId,
              detIds,
              journalId,
              username: username,
              companyId: companyId,
              dealDate,
              userIp,
              userCountry,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then((response) => {
            console.log("response", response);
            if (response?.data?.message?.errno === 1451) {
              swal({
                title: "Invalid Operation!",
                text: "There is a sale against this company deal property!",
                icon: "error",
                // button: "Try Again!",
              });
            } else {
              Swal.fire("Deleted!", "Your Record has been deleted.", "success");
              tempThis.getData();
            }
          })
          .catch((err) => {
            console.log(err);

            swal({
              title: "Failed!",
              text: "Internet Problem",
              icon: "error",
              button: "Try Again!",
            });
          });
      }
    });
  };
  setUpdate = async (cell, row) => {
    let rowId = row.id;

    axios
      .post(
        `${baseurl}/RealEstate/checkDealStatus`,
        {
          id: rowId,
          username: username,
          companyId: companyId,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        const result = response.data.data[0];

        if (result.payment_count > 0 || result.sale_count > 0) {
          swal({
            title: "Invalid Operation!",
            text: `There is a ${result.payment_count > 0 && "payment"} ${
              result?.payment_count > 0 && result?.sale_count > 0 ? "and" : ""
            } ${
              result.sale_count > 0 && "Sale"
            } against this company deal property!`,
            icon: "error",
          });
        } else {
          this.props.history.push({
            pathname: "/dealForm",
            state: { id: cell, updateCheck: 2 },
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  orderDetHandler = (cell, row) => {
    const { rolesPermission } = this.state;
    // 0 = add, 1 = disabled, 2 = update
    return (
      <div>
        <span>
          <span>
            <Link
              to={{
                pathname: "/dealForm",
                state: { id: cell, updateCheck: 1 },
              }}
            >
              <Button className="m-1" size="sm" title="Preview">
                <i className="fa fa-eye"></i>
              </Button>
            </Link>
          </span>
          <span>
            <Button
              style={{ margin: "3px" }}
              size="sm"
              color="primary"
              disabled={rolesPermission}
              onClick={() => this.setUpdate(cell, row)}
            >
            <i className="fa fa-edit"></i>
            </Button>
          </span>
        </span>
        <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            color="danger"
            onClick={() => this.setDelete(row)}
            disabled={rolesPermission}
          >
            <i className="fa fa-trash"></i>
          </Button>
        </span>
      </div>
    );
  };
  toggleAddNew = () => {
    this.setState({
      showItemForm: !this.state.showItemForm,
    });
  };
  toggleOpen = () => {
    this.setState({ showModalOpen: !this.state.showModalOpen });
  };
  handleChange(event) {
    this.setState({
      // Computed property names
      // keys of the objects are computed dynamically
      [event.target.name]: event.target.value,
    });
  }
  handleChangeEdit(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  addToggle = () => {
    this.setState({
      itemAdd: "",
    });
    this.toggleAddNew();
  };
  showDetailsModel = (cell) => {
    this.toggleOpen();
  };
  async componentDidMount() {
    await this.asyncRollCheck(0);
    if (this.state.permission) this.getData();
  }
  asyncRollCheck = async (value) => {
    let pathname = "/DealOverview";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };
  getData() {
    axios
      .post(
        `${baseurl}/RealEstate/getDeal`,
        {
          companyId: companyId,
          username: username,
          deal_Type_Id: 1,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let getItemData = res.data.data;

        this.setState({
          isLoadedTableData: true,
          tableData: getItemData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }
  render() {
    const { tableData, isLoadedTableData } = this.state;
    const options = {
      paginationShowsTotal: true,
      page: 1,
      sizePerPage: 5,
      pageStartIndex: 1,
      paginationSize: 5,
      prePage: "Prev",
      nextPage: "Next",
      firstPage: "First",
      lastPage: "Last",
      prePageTitle: "Go to previous",
      nextPageTitle: "Go to next",
      firstPageTitle: "Go to first",
      lastPageTitle: "Go to Last",
      paginationPosition: "top",
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "20",
          value: 20,
        },
        {
          text: "30",
          value: 30,
        },
        {
          text: "All",
          value: tableData.length,
        },
      ],
    };
    return (
      <div className="animated fadeIn">
        <>
          <div className="O-V-heading-bar">
            <div className="col-xs-8 col-md-6 mt-2">
              <strong>
                <h4>Deal Overview</h4>
              </strong>
            </div>
            <div className="col-xs-4 col-md-6 mt-1">
              <>
                <Link to="/waiterOverview" className="float-right mt-2">
                  <u className="Back-to-Overview text-dark">Back to Setup</u>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    color="black"
                    className="bi bi-chevron-left mx-2 "
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                    />
                  </svg>
                </Link>
              </>
            </div>
          </div>
        </>
        <div className="animated fadeIn">
          <div className="rowStyling mt-1">
            <Col>
              <div className="float-right mt-3">
                <Link to={"/dealForm"}>
                  <button
                    class="btn btn-outline-success rounded-pill mx-2"
                    title={"Create new Invoice"}
                    // disabled={this.state.rolesPermission}
                  >
                    <i class="fa fa-plus pr-2" aria-hidden="true"></i>
                    Add New Deal
                  </button>
                </Link>
              </div>
              <div>
                <div>
                  {isLoadedTableData ? (
                    <BootstrapTable
                      data={tableData}
                      striped
                      pagination
                      hover
                      search
                      tableHeaderClass="rpr_header"
                      tableBodyClass="rpr_body"
                      containerClass="rpr_container"
                      options={options}
                    >
                      <TableHeaderColumn
                        dataField="deal_date_formated"
                        dataAlign="center"
                        width="10%"
                        dataSort={true}
                      >
                        Deal Date
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="deal_no"
                        dataAlign="center"
                        width="7%"
                        dataSort={true}
                      >
                        Deal No
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="Party_Name"
                        dataAlign="center"
                        width="13%"
                        dataSort={true}
                        isKey={true}
                      >
                        Company
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="sociey_sector"
                        dataAlign="center"
                        width="13%"
                      >
                        Society/Sector
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="deal_desc"
                        dataAlign="center"
                        width="20%"
                        dataSort={true}
                      >
                        Description
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="num_of_prop"
                        dataAlign="center"
                        width="10%"
                        dataSort={true}
                      >
                        No. of Properties
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="cost_amount"
                        dataAlign="center"
                        width="11%"
                        dataSort={true}
                        dataFormat={(element) =>
                          dynamicCurrencyFormator({
                            cell: element,
                            overview: 1,
                            companySymbol: 1,
                          })
                        }
                      >
                        Cost Amount
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataAlign="center"
                        dataField="id"
                        width="15%"
                        dataFormat={this.orderDetHandler}
                      >
                        Action
                      </TableHeaderColumn>
                    </BootstrapTable>
                  ) : (
                    " Loading..."
                  )}
                </div>
              </div>
            </Col>
          </div>
        </div>
      </div>
    );
  }
}
export default DealOverview;
